export const PRIMARY_SALES_RETURN = {
    BASE_PATH: '/primary-sales-return/sales-return/',
    BASE_PATH_MAKE_PAYMENT: '/primary-sales-return/make-payment/',
    MAKE_PAYMENT_PATH(id: string | number) {
        return this.BASE_PATH + `${id}` + '/edit/make-payment';
    },
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    ADD_BUTTON_TITLE: 'Add New Primary Sales Return',
    LIST_PAGE_TITLE: 'Primary Sales Return List',
    EDIT_PAGE_TITLE: 'Edit Primary Sales Return',
    GET_ALL: 'primary-sale-return',
    GET_ALL_MAKE_PAYMENTS: 'primary-sale-return/payment',
    GET_ONE: 'primary-sale-return/edit/',
    CREATE: 'primary-sale-return/create',
    UPDATE: 'primary-sale-return/update/',
    DELETE: 'primary-sale-return/delete/',
    DELETE_MAKE_PAYMENT: 'primary-sale-return/payment/delete/',
    MAKE_PAYMENT: 'primary-sale-return/payment/update/',
    ADD_NEW_TITLE: 'Add New Primary Sales Return',
};
